import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
  userService,
} from 'app/services';
import { confirmDialog } from 'app/components/global';
import performAssessmentDialog from '../dialog.performAssessmentDialog';
import editInherentRiskProfileDialog from '../dialog.editInherentRiskProfileDialog';
import editMaturityProfileDialog from '../dialog.editMaturityProfileDialog';
import ecatGenerateDocumentDialog from './dialog.generateDocumentDialog';
import confirmCompleteAssessmentDialog from '../dialog.confirmCompleteAssessmentDialog';
import editAssessmentDocumentDialog from '../dialog.editAssessmentDocumentDialog';
import controller from './active-assessment.controller';
import directive from './active-assessment.directive';
//import criFunction from './cri/criFunction';
import editCRIProfileDialog from '../dialog.editCRIProfileDialog';

export default angular.module('app.components.advisory.ecat.activeAssessment', [
  confirmDialog,
  constants,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  performAssessmentDialog,
  editInherentRiskProfileDialog,
  editMaturityProfileDialog,
  ecatGenerateDocumentDialog,
  confirmCompleteAssessmentDialog,
  editAssessmentDocumentDialog,
  ssDialogService,
  userService,
  editCRIProfileDialog
])
  .directive('ecatActiveAssessment', directive)
  .controller('ECATActiveAssessmentController', controller)
  .name;

console.log('app.components.advisory.ecat.activeAssessment created');
